import numeral from 'numeral';

import { NumberFormattingOptions } from './types';
import { getFormatString } from './utils';

export function getCommaSeparatedNumber(
  num: number,
  options: Pick<NumberFormattingOptions, 'decimals' | 'strict'> = {},
) {
  let { decimals, strict } = options;
  let formatString = getFormatString({ decimals, strict, comma: true });
  return numeral(num).format(formatString);
}
